import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { IStatus } from "@shared/interfaces";


const MONTHS_EN = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", 
"Aug", "Sept", "Oct", "Nov", "Dec"];

@Injectable()
export class CommonService { 

    readonly DEFAULT_STATUS: IStatus = {
        created_at: new Date(),
        id: 0,
        name: 'None',
        updated_at: new Date()
    }

    private lastPage = '';
    private appLoaded: boolean = false;

    constructor(private router: Router) {}

    setAppLoaded(loaded: boolean) {
        this.appLoaded = loaded;
    }

    backNavigate() {
        const url = this.getLastPage();
        if(url?.length) {
          this.router.navigateByUrl(url);
          this.setLastPage('');
        } else {
          this.router.navigateByUrl('/');
        }
    }
    
    isAppLoaded() {
        return this.appLoaded;
    }

    setLastPage(page: string) {
        this.lastPage = page;
    }

    getLastPage(): string {
        return this.lastPage;
    }

    scrollToTop() {
        const main_el = document.querySelector('.main__mm')
        main_el?.scroll({
            top: 0, 
            left: 0, 
            behavior: 'smooth'
        });
    }

    dateFormat(date: Date) {
        const day = date.getDate();
        const hours = date.getHours() < 10 ? '0' + date.getHours(): date.getHours();
        const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        const year = date.getFullYear();
        
        const monthID = date.getMonth();
        const month = MONTHS_EN[monthID];

        return `${year} ${day} ${month} , ${hours}:${minutes}`;
    }

    numberFormat(value?: number, separator: string = ',') {
        if(value) {
          return value.toFixed(2).replace(/\./g, separator);
        }
        return `0${separator}00`;
    }

}